module.exports = __webpack_public_path__ + "images/android_device_icon.svg";